import { CheckOutStateEnum } from "store/type"
import { NO_ACTIVE_ORDER } from "../constants"
import { ConfirmationState, OrderState, ShippingState } from "../types"

//State Order
export const orderInitState: OrderState = {
	checkOutStateProduct: CheckOutStateEnum.LOADING,
	validatedLabelOrderStep: NO_ACTIVE_ORDER,
	products: [],
}

//State Shipping
export const shippingInitState: ShippingState = {
	invoicing_agent_firstname: "",
	invoicing_agent_lastname: "",
	invoicing_agent_mail: "",
	sepaInProgress: false,
	errorsBilingForm: [],
	localErrorBilingForm: false,
}

//State Confirmation
export const confirmationInitState: ConfirmationState = {
	orderCustomID: "",
	finishOrder: false,
	checkOutStateOrderPost: CheckOutStateEnum.READY,
}
